module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"manager_review_desc":"此評論是 %{brandName} 管理員註冊的評論。"}}')
  delete Component.options._Ctor
}
